import { render, staticRenderFns } from "./contentCarry.vue?vue&type=template&id=0086e77a&scoped=true"
import script from "./contentCarry.vue?vue&type=script&lang=js"
export * from "./contentCarry.vue?vue&type=script&lang=js"
import style0 from "./contentCarry.vue?vue&type=style&index=0&id=0086e77a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0086e77a",
  null
  
)

export default component.exports